import { Grid } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getTimeToServiceJobStage } from 'wisestep-api';
import { WsTypography } from 'wisestep-base';

import { stackedColumnData } from '../../types';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const TimeToServiceJobStage = ({ payload }: IPayloadDTOJobsCrm) => {
  const [aggregatedData, setAggregatedData] = useState<
    Record<
      string,
      {
        from?: number;
        to?: number;
        doc_count: number;
        aggregation: { doc_count: number; buckets: { key: string; doc_count: number }[] };
      }
    >
  >({});
  const [seriesData, setSeriesData] = useState<stackedColumnData[]>([{ name: '', data: [] }]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getTimeToServiceJobStage(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);

  useEffect(() => {
    const xCategories: string[] = Object.keys(aggregatedData);
    const seriesMap: Record<string, stackedColumnData> = {};

    Object.values(aggregatedData).map((obj, index) => {
      obj?.aggregation?.buckets.map((stageNameObj) => {
        const name = stageNameObj.key;
        const entryExists = Object.keys(seriesMap).indexOf(name) > -1;

        if (!entryExists) {
          const data = new Array(xCategories.length);
          data.fill(0);
          data.splice(0, 1, stageNameObj.doc_count);

          seriesMap[name] = { name, data };
        } else {
          seriesMap[name].data.splice(index, 1, stageNameObj.doc_count);
        }
      });
    });

    setSeriesData(Object.values(seriesMap));
    setCategories(xCategories);
  }, [aggregatedData]);

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      stacked: true,
    },
    yaxis: {
      title: { text: 'Count', style: { fontSize: '15px' } },
    },
    xaxis: {
      title: { text: 'Speed of Submission', style: { fontSize: '15px' } },
      categories: categories,
      type: 'category',
      offsetY: 0,
    },
  };
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={12}>
        <WsTypography>Impact of Speed of Submission</WsTypography>
        <ReactApexChart
          options={options}
          type="bar"
          series={seriesData}
          title="Time to Service"
          height={400}
        />
      </Grid>
    </Grid>
  );
};

export default TimeToServiceJobStage;
